@if(user) {
  <div class="row white-bg">
    <div class="col-sm-9">
      <h1>{{ user.fullname }}</h1>
      <dl>
        @for(role of user.permissions; track role) {
          @if(!role.startsWith('OP_')) {
            <dd>
              <h3>
                <button (click)="unassign(role)" class="btn btn-danger btn-sm">
                  <i class="fas fa-times"></i>
                </button>
                Rôle : {{ role }}
              </h3>
            </dd>
          }
          @if(user.isRoot() && role.startsWith('OP_')) {
            <dd>{{ role }}</dd>
          }
        }
      </dl>
      <div class="form-group">
        <label>Ajout du rôle</label>
        <div class="input-group">
          @if(allRoles) {
            <select [(ngModel)]="newRole" class="form-control">
              <option></option>
              @for(role of availableRoles(); track role) {
                @if(!user.hasRole(role)) {
                  <option [value]="role.id">{{
                      role.name
                    }}</option>
                }
              }
            </select>
          }

          <span class="input-group-btn">
            <button
              class="btn btn-primary"
              (click)="addRole()"
              [disabled]="!newRole"
            >
              <i class="far fa-check"></i> Ajouter
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
}
